import { FormattedMessage } from 'react-intl';

import { RivalsLightning } from '@sorare/core/src/components/rivals/RepScore/RivalsLightning';
import { navLabels } from '@sorare/core/src/lib/glossary';

import { Block } from '../Block';

export type Props = {
  noPadding?: boolean;
  hideHeader?: boolean;
};

export const Rivals = ({
  children,
  noPadding,
  hideHeader,
}: React.PropsWithChildren<Props>) => {
  return (
    <Block
      noPadding={noPadding}
      hideHeader={hideHeader}
      title={<FormattedMessage {...navLabels.rivals} />}
      icon={<RivalsLightning fill="var(--c-neutral-1000)" />}
    >
      {children}
    </Block>
  );
};
